require('./cardStatementInformationView.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
const cardsStatementsActions = require('actions/getCardsStatements');
const cardsStatementDetailsActions = require('actions/getCardsStatementDetails');

// @utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname')

// @components
const CardStatementList = require('components/cards/cardStatementList/cardStatementList');
const CardStatementDetails = require('components/cards/cardStatementDetails/cardStatementDetails');
const { LoadingSection } = require('commonsComponents/loadingSection');
const WebappRender = require('components/conditionalRender/webappRender')

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @constants
const { DATE_FORMAT_FULL_MONTH_YEAR } = require('constants/index');

class CardStatementInformationView extends React.Component {
    componentDidMount() {
        const { history, match: { params: { cardId, statementId } }, immCards } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_STATEMENT_INFORMATION, { immCard }, history);
        this.props.requestCardStatementDetails(cardId, statementId);
    }

    render() {
        const { match: { params: { cardId, statementId } }, immCards, immStatements, immCardsStatementDetails } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const immStatementDetails = immCardsStatementDetails.getIn([statementId, 'details']);
        let content;

        if (immCard && immStatementDetails) {
            const date = DateHelper.buildFormattedDate(immStatementDetails.get('date'), DATE_FORMAT_FULL_MONTH_YEAR);
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardStatement-statements'),
                    url: `/myprofile/cards/${cardId}/statements`
                },
                {
                    text: formatText('cardStatement-statementInformation')
                }
            ];

            const cardStatementInformationClassName = contactCenterClassName('card-statement-information-view')
            const cardStatementInformationBodyClassName = contactCenterClassName('card-statement-information-view__body', 'grid-view__body')
            const cardStatementInformationContainerClassName = contactCenterClassName('card-statement-information-view__container', 'container-fluid')
            const cardStatementInformationListClassName = conditionalClassName('col-md-12', 'col-md-8', 'col-lg-8')
            const cardStatementInformationDetailsClassName = conditionalClassName('hidden-md', 'card-statement-information-view__details col-md-4', 'hidden-xs hidden-sm col-lg-4')

            content = (
                <div className={cardStatementInformationClassName}>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={getFinalTitle('cardStatement-detailTitle', [date])}>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={cardStatementInformationBodyClassName}>
                        <div className={cardStatementInformationContainerClassName}>
                            <div className="row grid-view--content-position-negative">
                                {/* >> CONTENT DUPLICATED: REF-01 */}
                                <WebappRender>
                                    <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                        <CardStatementDetails
                                            immStatements={immStatements.get(cardId)}
                                            statementId={statementId}
                                            immStatementDetails={immStatementDetails}
                                        />
                                    </div>
                                </WebappRender>
                                {/* CONTENT DUPLICATED: REF-01 << */}
                                <div className={cardStatementInformationListClassName}>
                                    <CardStatementList
                                        immStatementDetails={immStatementDetails}
                                        immCard={immCard}
                                    />
                                </div>
                                {/* >> REF-01 */}
                                <div className={cardStatementInformationDetailsClassName}>
                                    <CardStatementDetails
                                        immStatements={immStatements.get(cardId)}
                                        statementId={statementId}
                                        immStatementDetails={immStatementDetails}
                                        cardType={__CONTACT_CENTER__ ? type : undefined}
                                    />
                                </div>
                                {/* REF-01 << */}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

CardStatementInformationView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immStatements: PropTypes.object.isRequired,
    immCardsStatementDetails: PropTypes.object.isRequired,
    requestCardStatements: PropTypes.func.isRequired,
    requestCardStatementDetails: PropTypes.func.isRequired
};

module.exports.constructor = CardStatementInformationView;
module.exports.CardStatementInformationView = connect(
    state => ({
        immCards: state.cards,
        immStatements: state.cardsStatements,
        immCardsStatementDetails: state.cardsStatementDetails
    }), {
    requestCardStatements: cardsStatementsActions.requestCardStatements,
    requestCardStatementDetails: cardsStatementDetailsActions.requestCardStatementDetails
}
)(withRouter(CardStatementInformationView));
